import React, { useEffect } from 'react';
import { useState } from "react";
import {
    Alert,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    TextField
} from '@mui/material';
import dayjs from 'dayjs';
import { useHistory } from "react-router-dom";
import FormManagerLogin from '../../components/FormManagerLogin/FormManagerLogin';
import HomeIcon from '@mui/icons-material/Home';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { EventNote } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
const NoEvent = (data) => {
    const history = useHistory();
    const [isCheckIn, setIsCheckIn] = React.useState(false);
    const userId = data?.location?.state?.data?.users?.$values[0].userId ?? data?.location?.state?.data.userId;
    const [openProgressBar, setOpenProgressBar] = useState(false);
    const [error, setError] = useState(null);
    const [event, setEvent] = useState(null);
    const [inactiveEventMessage, setInactiveEventMessage] = useState("");

    useEffect(() => {
        const syncInactiveEventMessage = async () => {
            const defaultEventId = localStorage.getItem('defaultEventId');
            if (defaultEventId && defaultEventId.trim() !== "") {
                try {
                    const response = await fetch(`/api/Event/GetEventById?id=${defaultEventId}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                            'Content-Type': 'application/json'
                        }
                    });
                    const data = await response.json();
                    const eventEndDate = data?.events?.$values?.[0]?.eventEndDate;

                    if (eventEndDate && dayjs(eventEndDate).isBefore(dayjs().startOf('day'))) {
                        localStorage.setItem('defaultEventId', "");
                        localStorage.setItem('eventInactiveMessage', 'The previously selected event is no longer active. Please select another active event.');
                    }
                } catch (ex) {
                    // Keep current page behavior if event lookup fails.
                }
            }

        const message = localStorage.getItem('eventInactiveMessage');
        if (message) {
            setInactiveEventMessage(message);
        }
        };

        syncInactiveEventMessage();
    }, []);

    const handleCloseProgressBar = () => {
        setOpenProgressBar(false);
    };

    return (
        <>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={11} md={11}>
                    <div class="bg-white rounded-lg shadow-lg max-w-lg mx-auto p-8 text-center">
                        {inactiveEventMessage && (
                            <div className="mb-4">
                                <Alert severity="warning">{inactiveEventMessage}</Alert>
                            </div>
                        )}
                        <div className="text-center max-w-md mx-auto space-y-4 p-4">
                            <p class="text-pink-800 font-bold mb-6">PLEASE LOGIN TO MANAGE CHECK-IN EVENTS</p>
                        </div>
                        <div className="text-center max-w-md mx-auto space-y-4 p-4">                        
                            <FormManagerLogin />
                        </div>
                    </div>
                </Grid>
            </Grid >
            <Backdrop
                open={openProgressBar}
                onClick={handleCloseProgressBar}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default NoEvent;